import {
  ProcessedScanResult,
  ScanResultType
} from "../../components/Pages/Diary/SpaceScanner/SpaceScanner.types";
import { ScanDecision } from "./types/ScanHistory.types";

const PERMANENTLY_EXCLUDED_TYPES: ScanResultType[] = [
  "booking_started",
  "booking_locked",
  "booking_locked_deposit",
  "booking_locked_preorder",
  "booking_locked_manual",
  "booking_guestlist",
  "booking_left",
  "booking_waitlisted",
  "booking_noshow",
  "area_closed"
];

export const buildDecisionsFromResults = (
  results: ProcessedScanResult[],
  venueId: string,
  scanSessionId: string
): ScanDecision[] => {
  const now = Date.now();

  return results
    .filter((r) => !PERMANENTLY_EXCLUDED_TYPES.includes(r.result))
    .map((result) => {
      const booking = result.booking as typeof result.booking & {
        labels?: string[];
      };

      return {
        venueId,
        scanSessionId,
        timestamp: now,
        bookingId: booking._id,
        bookingType: result.booking.type?.name ?? "Unknown",
        partySize: result.booking.num_people,
        fromAreaId: result.previousAreas?.[0]?.id ?? "",
        fromAreaName: result.previousAreas?.[0]?.name ?? "Unassigned",
        toAreaId: result.newAreas?.[0]?.id ?? "",
        toAreaName: result.newAreas?.[0]?.name ?? "Unassigned",
        accepted: result.moved,
        resultType: result.result,
        labels: booking.labels ?? [],
        timeSlot: result.booking.time ?? "",
        scanApplied: false
      };
    });
};
